export function findPath(str: string): string {
  const parts = str.split("/");
  if (parts.length <= 2) {
    return "";
  }
  return "/" + parts.slice(2).join("/");
}
